import * as React from 'react';

function SvgExternal(props) {
  return (
    <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
      <path
        fill="none"
        d="M6.857 4H4v12h12v-2.857M7.429 12.571L16 4M16 8.571V4H11.43"
        stroke={props.color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SvgExternal;
